//Clevertar object
var gqa = {};

// create global variable for widget
window.WidgetState;

const genesysDeploymentId = "aac69a7e-9b73-42cf-9ff3-b053666eaa6d";
window.genesysDeploymentId = genesysDeploymentId;

function loadGTMTags() {
    const gtmTagId = window.gtmTagId ?? "";
    (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
            "gtm.start": new Date().getTime(),
            event: "gtm.js",
        });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, "script", "dataLayer", gtmTagId);
}

//Loading Clevertar Window
function loadWidget() {
    return new Promise((resolve, reject) => {
        const tryToggleView = () => {
            try {
                gqa.toggleView(true);
                // If the genesys chat is open, close it
                if (window.closeLauncher !== undefined) {
                    window.closeLauncher();
                }
                if (window.Genesys !== undefined) {
                    window.Genesys("command", "Messenger.close");
                    try {
                        window.Genesys("command", "Launcher.hide");
                    } catch (error) {
                        // Gensys launcher config is cooked
                    }
                }

                resolve();
            } catch (error) {
                console.error(error);
                console.log("waiting for clevertar");
                setTimeout(tryToggleView, 250);
            }
        };
        tryToggleView();
    });
}

let clevertarPromise = null;
let genesysPromise = null;

function loadClevertar() {
    if (clevertarPromise) {
        return clevertarPromise;
    }

    clevertarPromise = new Promise((resolve, reject) => {
        const src = "https://components.clevertar.app/clients/mate/gqa/gqa-custom.js";

        if (document.querySelector(`script[src="${src}"`)) {
            resolve();
            return;
        }

        const clevertarscript = document.createElement("script");
        clevertarscript.onload = function () {
            resolve();

            gqa_functions.init();

            if (document.querySelector("#clevertarPsudoButton")) {
                document.querySelector("#clevertarPsudoButton").remove();
            }
        };

        clevertarscript.setAttribute("src", src);
        document.head.appendChild(clevertarscript);
    });

    return clevertarPromise;
}

function triggerClevertar(ref = null, cat = "General") {
    console.log(ref + " " + cat);
    $("#clevertarPsudoButton").remove();

    openAiChat();
}

//This loads all the required info
async function afterLoad() {
    loadGTMTags();

    // https://help.mypurecloud.com/articles/predictive-engagement-tracking-snippet/
    (function (a, t, c, l, o, u, d) {
        a["_genesysJourneySdk"] = o;
        (a[o] =
            a[o] ||
            function () {
                (a[o].q = a[o].q || []).push(arguments);
            }),
            (a[o].l = 1 * new Date());
        (u = t.createElement(c)), (d = t.getElementsByTagName(c)[0]);
        u.async = 1;
        u.src = l;
        u.charset = "utf-8";
        d.parentNode.insertBefore(u, d);
    })(window, document, "script", "https://apps.mypurecloud.com.au/journey/sdk/js/web/v1/ac.js", "ac");
    ac("init", "0a5aa6b5-67c0-4f6b-ba71-eb78bf55dfa7", { region: "apse2" });
    ac("pageview");

    // __cl_open_onRefresh is a clevertar local storage item in old widget - now its "clevertar.openOnRefresh"
    if (localStorage.getItem("clevertar.openOnRefresh") == "true") {
        triggerClevertar();
    }

    jQuery(document).on("click", ".clevertar-trigger", function (e) {
        e.preventDefault();

        //* push to GTM
        var ref = $(this).data("clevertarref");
        var cat = $(this).data("clevertarcat");
        cat = typeof cat === "undefined" ? "General" : cat;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "grace_ai_interactions",
            clevartarRef: ref,
            clevartarCat: cat,
        });

        //* if button is in a modal, close that modal
        $(this).find(".modal").modal("hide");
        if (typeof ref !== "undefined") {
            triggerClevertar(ref, cat);
        }
    });

    jQuery(document).on("click", ".hf-chat", async function (e) {
        e.preventDefault();

        openAiChat();
    });

    // if there is a genesys live chat session, load genesys
    let session = JSON.parse(localStorage.getItem(`_${window.genesysDeploymentId}:gcmcsessionActive`));
    if (session?.value) {
        const chatLauncherStartTime = JSON.parse(localStorage.getItem(`_livechat_launcher_triggered`));
        const timeToKeep = 1000 * 60 * 60 * 1; // 1 hour
        if (chatLauncherStartTime && parseInt(chatLauncherStartTime) + timeToKeep > Date.now()) {
            openLiveChat();
            return;
        }
    }

    loadClevertar();
    loadGenesys();
}

async function loadGenesys() {

    if (genesysPromise) {
        return genesysPromise;
    }

    genesysPromise = new Promise((resolve, reject) => {
        (function (g, e, n, es, script) {
            g["_genesysJs"] = e;
            g[e] =
                g[e] ||
                function () {
                    (g[e].q = g[e].q || []).push(arguments);
                };
            g[e].t = 1 * new Date();
            g[e].c = es;
            script = document.createElement("script");
            script.async = 1;
            script.src = n;
            script.charset = "utf-8";
            document.head.appendChild(script);
            script.onload = resolve;
        })(window, "Genesys", "https://apps.mypurecloud.com.au/genesys-bootstrap/genesys.min.js", {
            environment: "apse2",
            deploymentId: window.genesysDeploymentId,
            debug: true,
        });
    });

    return genesysPromise;
}

let genesysCustomLauncherPromise = null;
async function loadGenesysCustomLauncher() {

    if (genesysCustomLauncherPromise) {
        return genesysCustomLauncherPromise;
    }

    genesysCustomLauncherPromise = new Promise((resolve, reject) => {
        var src = "/includes/assets/js/genesys-custom-launcher.js";
        if ($('script[src="' + src + '"]').length == 0) {
            const script = document.createElement("script");
            script.onload = resolve;
            script.setAttribute("src", src);
            document.head.appendChild(script);
        } else {
            resolve();
        }
    });

    return genesysCustomLauncherPromise;
}

if (window.attachEvent) {
    window.attachEvent("onload", afterLoad);
} else {
    if (window.onload) {
        var curronload = window.onload;
        var newonload = function (evt) {
            curronload(evt);
            afterLoad(evt);
        };
        window.onload = newonload;
    } else {
        window.onload = afterLoad;
    }
}

async function openLiveChat() {
    if (typeof gqa !== "undefined" && typeof gqa.toggleView !== "undefined") {
        gqa.toggleView(false);
        gqa.showBadge(false);
        closeAi();
    }

    await loadGenesys();
    await loadGenesysCustomLauncher();

    openLauncher();

    // set a chatWindowStartTime local storage item to the current time
    localStorage.setItem(`_livechat_launcher_triggered`, JSON.stringify(Date.now()));
}

async function openAiChat() {
    // If there is already a chat session open, open the chat window
    let session = JSON.parse(localStorage.getItem(`_${window.genesysDeploymentId}:gcmcsessionActive`));
    if (session?.value) {
        const chatLauncherStartTime = JSON.parse(localStorage.getItem(`_livechat_launcher_triggered`));
        const timeToKeep = 1000 * 60 * 60 * 1; // 1 hour
        if (chatLauncherStartTime && parseInt(chatLauncherStartTime) + timeToKeep > Date.now()) {
            await openLiveChat();
            Genesys("command", "Messenger.open");
            return;
        }
    }

    $("#clevertarPsudoButton").hide();
    await loadClevertar();
    loadWidget();
}
